module.exports = __webpack_public_path__ + "static/img/GNSS04.84517920.png";